namespace Indexes {
    export class Order
    implements StaticIndexDefinition {

        name = "OrderAll";
        maps = [
            "from u in docs.Orders select new { u.closed, u.dateTimeStart, u.userId }"
        ];
    }
}